import {
  ALACARTE_REQUEST_GET_BY_ID,
  ALACARTE_REQUEST_GET_BY_ID_SUCCESS,
  ALACARTE_REQUEST_GET_BY_ID_ERROR,
  ALACARTE_REQUEST_GET_LIST,
  ALACARTE_REQUEST_GET_LIST_SUCCESS,
  ALACARTE_REQUEST_GET_LIST_ERROR,
  ALACARTE_REQUEST_GET_LIST_WITH_FILTER,
  ALACARTE_REQUEST_GET_LIST_WITH_FILTER_SUCCESS,
  ALACARTE_REQUEST_GET_LIST_WITH_FILTER_ERROR,

  REQUEST_GET_LIST_DELTA,
  REQUEST_GET_LIST_DELTA_SUCCESS,
  REQUEST_GET_LIST_DELTA_ERROR,
  REQUEST_GET_LIST_WITH_FILTER,
  REQUEST_GET_FAST_CHECK_IN_LIST_WITH_FILTER,
  REQUEST_GET_ALACARTE_LIST_WITH_FILTER,
  REQUEST_GET_ALACARTE_STATUS_FILTER,
  REQUEST_GET_ALACARTE_LIST_WITH_ORDER,
  REQUEST_GET_ALACARTE_LIST_WITH_RESTAURANT,
  REQUEST_GET_FAST_CHECK_IN_LIST_WITH_ORDER,
  REQUEST_GET_LIST_WITH_ORDER,
  REQUEST_GET_LIST_SEARCH,
  REQUEST_GET_FAST_CHECK_IN_LIST_SEARCH,
  REQUEST_ADD_ITEM,
  REQUEST_ADD_ITEM_SUCCESS,
  REQUEST_ADD_ITEM_ERROR,
  REQUEST_SELECTED_ITEMS_CHANGE,
  CHANGE_LANGUAGE_FOR_REQUEST_ITEMS,
  COMMENT_ADD_ITEM,
  COMMENT_ADD_ITEM_SUCCESS,
  COMMENT_ADD_ITEM_ERROR,
  REQUEST_GET_ITEM,
  REQUEST_GET_ITEM_SUCCESS,
  REQUEST_GET_ITEM_ERROR,
  SET_IS_TRANSLATION_NEEDED,
  REQUEST_SHOW_TOAST_SET,
  REQUEST_CREATE_QR_IMAGE,
  REQUEST_CREATE_QR_IMAGE_SUCCESS,
  REQUEST_CREATE_QR_IMAGE_ERROR,
  REQUEST_CREATE_QR_IMAGE_DEEP_LINK,
  REQUEST_CREATE_QR_IMAGE_DEEP_LINK_SUCCESS,
  REQUEST_CREATE_QR_IMAGE_DEEP_LINK_ERROR,
  LOL_REQUESTS_WITH_FILTER,
  LOL_REQUESTS_WITH_ORDER,
  LOL_REQUESTS_SEARCH,
  TEMPLATE_ADD_MESSAGE,
  TEMPLATE_ADD_MESSAGE_SUCCESS,
  TEMPLATE_ADD_MESSAGE_ERROR,
  SET_REQUEST_LOADING,
} from "../actions";

export const setRequestLoading = (items) => ({
  type: SET_REQUEST_LOADING,
  payload: items
});

export const getAlacarteRequestById = items => ({
  type: ALACARTE_REQUEST_GET_BY_ID,
  payload: items
});

export const getAlacarteRequestByIdSuccess = items => ({
  type: ALACARTE_REQUEST_GET_BY_ID_SUCCESS,
  payload: items
});

export const getAlacarteRequestByIdError = error => ({
  type: ALACARTE_REQUEST_GET_BY_ID_ERROR,
  payload: error
});

export const getAlacarteRequestList = items => ({
  type: ALACARTE_REQUEST_GET_LIST,
  payload: items
});

export const getAlacarteRequestListSuccess = items => ({
  type: ALACARTE_REQUEST_GET_LIST_SUCCESS,
  payload: items
});

export const getAlacarteRequestListError = error => ({
  type: ALACARTE_REQUEST_GET_LIST_ERROR,
  payload: error
});

export const getAlacarteRequestListWithFilter = items => ({
  type: ALACARTE_REQUEST_GET_LIST_WITH_FILTER,
  payload: items
});

export const getAlacarteRequestListWithFilterSuccess = items => ({
  type: ALACARTE_REQUEST_GET_LIST_WITH_FILTER_SUCCESS,
  payload: items
});

export const getAlacarteRequestListWithFilterError = error => ({
  type: ALACARTE_REQUEST_GET_LIST_WITH_FILTER_ERROR,
  payload: error
});


export const getRequestListDelta = fetchMore => ({
  type: REQUEST_GET_LIST_DELTA,
  payload: fetchMore
});

export const getRequestListDeltaSuccess = (items, allLoaded) => ({
  type: REQUEST_GET_LIST_DELTA_SUCCESS,
  payload: { items, allLoaded }
});

export const getRequestListDeltaError = error => ({
  type: REQUEST_GET_LIST_DELTA_ERROR,
  payload: error
});

export const getRequestListWithFilter = (column, value) => ({
  type: REQUEST_GET_LIST_WITH_FILTER,
  payload: { column, value }
});

export const getRequestFastCheckinListWithFilter = (column, value) => ({
  type: REQUEST_GET_FAST_CHECK_IN_LIST_WITH_FILTER,
  payload: { column, value }
});

export const getRequestAlacarteListWithFilter = items => ({
  type: REQUEST_GET_ALACARTE_LIST_WITH_FILTER,
  payload: items
});

export const getRequestAlacarteStatusFilter = (column, value) => ({
  type: REQUEST_GET_ALACARTE_STATUS_FILTER,
  payload: { column, value }
});

export const getRequestAlacarteListWithOrder = (column, direction = "desc") => ({
  type: REQUEST_GET_ALACARTE_LIST_WITH_ORDER,
  payload: { column, direction }
});

export const getRequestAlacarteListWithRestaurant = (column, value) => ({
  type: REQUEST_GET_ALACARTE_LIST_WITH_RESTAURANT,
  payload: { column, value }
});

export const getRequestFastCheckinListWithOrder = (column, direction = "desc") => ({
  type: REQUEST_GET_FAST_CHECK_IN_LIST_WITH_ORDER,
  payload: { column, direction }
});
export const getRequestFastCheckinListSearch = keyword => ({
  type: REQUEST_GET_FAST_CHECK_IN_LIST_SEARCH,
  payload: keyword
});

export const getRequestListWithOrder = (column, direction = "desc") => ({
  type: REQUEST_GET_LIST_WITH_ORDER,
  payload: { column, direction }
});
export const getRequestListSearch = keyword => ({
  type: REQUEST_GET_LIST_SEARCH,
  payload: keyword
});

export const addRequestItem = item => ({
  type: REQUEST_ADD_ITEM,
  payload: item
});

export const addRequestItemSuccess = items => ({
  type: REQUEST_ADD_ITEM_SUCCESS,
  payload: items
});

export const addRequestItemError = snapshotAndError => ({
  type: REQUEST_ADD_ITEM_ERROR,
  payload: snapshotAndError
});

export const addCommentItem = item => ({
  type: COMMENT_ADD_ITEM,
  payload: item
});

export const addCommentItemSuccess = items => ({
  type: COMMENT_ADD_ITEM_SUCCESS,
  payload: items
});

export const addCommentItemError = snapshotAndError => ({
  type: COMMENT_ADD_ITEM_ERROR,
  payload: snapshotAndError
});

export const updateTempMessage = item => ({
  type: "UPDATE_TEMP_MESSAGE",
  payload: item
});

export const updateTempMessageSuccess = items => ({
  type: "UPDATE_TEMP_MESSAGE_SUCCESS",
  payload: items
});

export const updateTempMessageError = snapshotAndError => ({
  type: "UPDATE_TEMP_MESSAGE_ERROR",
  payload: snapshotAndError
});

export const putTempMessage = item => ({
  type: "PUT_TEMP_MESSAGE",
  payload: item
});

export const putTempMessageSuccess = items => ({
  type: "PUT_TEMP_MESSAGE_SUCCESS",
  payload: items
});

export const putTempMessageError = snapshotAndError => ({
  type: "PUT_TEMP_MESSAGE_ERROR",
  payload: snapshotAndError
});

export const addTempMessage = item => ({
  type: TEMPLATE_ADD_MESSAGE,
  payload: item
});

export const addTempMessageSuccess = items => ({
  type: TEMPLATE_ADD_MESSAGE_SUCCESS,
  payload: items
});

export const addTempMessageError = snapshotAndError => ({
  type: TEMPLATE_ADD_MESSAGE_ERROR,
  payload: snapshotAndError
});

export const requestGetItem = item => ({
  type: REQUEST_GET_ITEM,
  payload: item
});

export const requestGetItemSuccess = items => ({
  type: REQUEST_GET_ITEM_SUCCESS,
  payload: items
});

export const requestGetItemError = error => ({
  type: REQUEST_GET_ITEM_ERROR,
  payload: error
});

export const templateGetItem = () => ({
  type: "TEMPLATE_GET_ITEM"
});

export const templateGetItemSucces = items => ({
  type: "TEMPLATE_GET_ITEM_SUCCES",
  payload: items
});

export const templateGetItemError = error => ({
  type: "TEMPLATE_GET_ITEM_ERROR",
  payload: error
});

export const selectedRequestItemsChange = selectedItems => ({
  type: REQUEST_SELECTED_ITEMS_CHANGE,
  payload: selectedItems
});

export const changeLanguageForRequestItems = payload => ({
  type: CHANGE_LANGUAGE_FOR_REQUEST_ITEMS,
  payload
});

export const setIsTranslationNeeded = isTranslationNeeded => ({
  type: SET_IS_TRANSLATION_NEEDED,
  payload: isTranslationNeeded
});

export const setRequestShowToast = visible => ({
  type: REQUEST_SHOW_TOAST_SET,
  payload: visible
});

export const createRequestQrImage = items => ({
  type: REQUEST_CREATE_QR_IMAGE,
  payload: items
});

export const createRequestQrImageSuccess = items => ({
  type: REQUEST_CREATE_QR_IMAGE_SUCCESS,
  payload: items
});

export const createRequestQrImageError = error => ({
  type: REQUEST_CREATE_QR_IMAGE_ERROR,
  payload: error
});

export const createRequestQrImageDeepLink = items => ({
  type: REQUEST_CREATE_QR_IMAGE_DEEP_LINK,
  payload: items
});

export const createRequestQrImageDeepLinkSuccess = items => ({
  type: REQUEST_CREATE_QR_IMAGE_DEEP_LINK_SUCCESS,
  payload: items
});

export const createRequestQrImageDeepLinkError = error => ({
  type: REQUEST_CREATE_QR_IMAGE_DEEP_LINK_ERROR,
  payload: error
});

export const getLolRequestsWithFilter = (column, value) => ({
  type: LOL_REQUESTS_WITH_FILTER,
  payload: { column, value }
});

export const getLolRequestsWithOrder = (column, value) => ({
  type: LOL_REQUESTS_WITH_ORDER,
  payload: { column, value }
});

export const getLolRequestsSearch = keyword => ({
  type: LOL_REQUESTS_SEARCH,
  payload: keyword
});
